import { memo, useCallback } from "react";
import { closeAllModals, openModal } from "@mantine/modals";
import CardReport from "../CardReport";
import GetDetailInfo from "../GetDetailInfo";
import TableReport from "./TableReport";
import {
  CustomReportInput,
  useDownloadCardsExpirationReportLazyQuery,
} from "src/generated/graphql";
import useReport from "src/hooks/useReport";
import { downloadCSV, getFileNameCsv } from "src/utils/utils";

const title = "Credit Cards by Expiration";
function CardsExpirationReport() {
  const { openDownloadModal, handleReportView } = useReport();

  const [downloadCardsExpirationCsv] =
    useDownloadCardsExpirationReportLazyQuery({
      onCompleted: () => {
        closeAllModals();
      },
    });

  const handleReportDownload = async (filters: CustomReportInput) => {
    openDownloadModal(title);
    const { startAt, endAt, locations } = filters;
    const { data } = await downloadCardsExpirationCsv({
      variables: {
        data: {
          startAt,
          endAt,
          locations: locations,
        },
      },
    });

    downloadCSV(
      data?.downloadCardsExpirationReport,
      getFileNameCsv("CreditCardsByExpirationDate_", [startAt, endAt])
    );
  };

  const handleView = (values: CustomReportInput) => {
    handleReportView(<TableReport values={values} />);
  };

  const handleSubmit = (values: CustomReportInput, isdownload: boolean) => {
    closeAllModals();
    isdownload ? handleReportDownload(values) : handleView(values);
  };

  const handleModal = useCallback((isdownload: boolean) => {
    openModal({
      closeOnClickOutside: false,
      title,
      children: (
        <GetDetailInfo
          handleSubmit={(values) => handleSubmit(values, isdownload)}
        />
      ),
    });
  }, []);

  return <CardReport title={title} handleModal={handleModal} />;
}

export default memo(CardsExpirationReport);
